import { createStyles, makeStyles } from '@material-ui/styles';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            border: "2px dashed ".concat(theme.palette.background.b9),
            padding: '8px 12px',
            color: theme.palette.text.primary,
            '&:disabled': {
                border: "2px dashed ".concat(theme.palette.type === 'light' ? theme.palette.border.dark : theme.palette.border.main),
                color: theme.palette.text.hint,
            },
            '&:hover, &:focus': {
                border: "2px solid ".concat(theme.palette.background.b10),
                backgroundColor: 'transparent',
            },
            '&:active': {
                borderColor: theme.palette.action.active,
            },
        },
    });
});
//# sourceMappingURL=DashedButton.styles.js.map